The external identifier for the verification request.
